import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import * as API from "../utils/api";

export const ConsumerPortalSelectContext = createContext();

const ConsumerPortalSelectProvider = ({ children }) => {
  const { authState } = useAuth();
  const navigate = useNavigate();

  const [selectState, setSelectState] = useState({
    selectedOption: "",
    dropdownOptions: [],
  });

  useEffect(() => {
    if (
      authState?.user?.id &&
      !authState?.user?.admin &&
      !authState?.user?.client_admin &&
      !authState?.user?.super_admin &&
      !authState?.user?.is_employee
    ) {
      fetchSubAccounts();
    }
  }, [authState?.user]);

  const handleSelectValue = (event) => {
    const id = event.target.value;
    setSelectState((prevState) => {
      return {
        ...prevState,
        selectedOption: id,
      };
    });

    // Redirect to invoices page when an account is selected
    navigate("/dashboard/accounts/invoices/");
  };

  const fetchSubAccounts = async () => {
    const res = await API.getConsumerSubAccountList(
      authState.user,
      authState.user.id
    );
    if (res?.sub_accounts) {
      setSelectState((prevState) => {
        return {
          ...prevState,
          selectedOption: "",
          dropdownOptions: [
            ...(res.sub_accounts.length > 0
              ? [
                  {
                    id: "",
                    display_name: `${authState?.user?.display_name || authState?.user?.first_name + " " + authState?.user?.last_name} (Parent)`,
                  },
                ]
              : []),
            ...res.sub_accounts,
          ],
        };
      });
    }
  };

  return (
    <ConsumerPortalSelectContext.Provider
      value={{
        selectState,
        handleSelectValue,
      }}
    >
      {children}
    </ConsumerPortalSelectContext.Provider>
  );
};

export const useConsumerPortalSelect = () => {
  return useContext(ConsumerPortalSelectContext);
};

export default ConsumerPortalSelectProvider;
